export default "__VITE_ASSET__Dvzlq_Tj__"